import IconButton from '../../../../../components/atoms/button/IconButton';
import Input from '../../../../../components/atoms/input';
import { AnswerAlternativeData } from '../../../../../types/contentTypes';

import './AnswerAlternative.scss';

interface AnswerProps {
  answerAlternative: AnswerAlternativeData;
  index: number;
  onMarkAsCorrect: () => void;
  onAnswerChange: (value: string) => void;
  onFeedbackChange: (value: string) => void;
  onDelete?: () => void;
  className?: string;
}

export default function AnswerAlternative({
  answerAlternative: alternative,
  index,
  onMarkAsCorrect,
  onAnswerChange,
  onFeedbackChange,
  onDelete,
  className,
}: AnswerProps) {
  return (
    <div className={`answer-alternative ${onDelete ? 'show-delete' : ''} ${className}`}>
      <Input
        type="text"
        value={alternative.answer}
        onChange={({ target: { value } }) => onAnswerChange(value)}
        placeholder={`Answer alternative ${index + 1}`}
        required={true}
      />
      <div className="flex items-center">
        <input
          className="radio-button mr-4"
          id={`correct-${index}`}
          type="radio"
          checked={alternative.correct}
          onChange={onMarkAsCorrect}
        />
        {alternative.correct ? (
          <label className="text-green" htmlFor={`correct-${index}`}>
            Correct answer
          </label>
        ) : (
          <label className="text-red" htmlFor={`correct-${index}`}>
            Incorrect answer
          </label>
        )}
      </div>
      <Input
        className="w-full"
        value={alternative.feedback}
        onChange={({ target: { value } }) => onFeedbackChange(value)}
        placeholder={`Feedback ${index + 1}`}
      />
      {onDelete && <IconButton icon="close" visualType="no-bg" onClick={onDelete} />}
    </div>
  );
}
